const Nutrition = (app) => {
  app
    // Create or update a nutrition plan
    .post(
      "/nutrition/save/:plan?",
      async ({ req, res, flash, api, locals }) => {
        const { body, params, query = {} } = req;
        const { proxyAthlete } = query;
        const { plan } = params;

        if (!plan) {
          body.coachId = locals.activeUserToRequest._id;
          await api(`nutrition-plan/?proxyAthlete=${proxyAthlete}`, {
            method: "POST",
            body,
          });
          flash("success", "Successfully created");
        } else {
          if (!body.restDay) {
            body.restDay = null;
          }

          await api(`nutrition-plan/${plan}/?proxyAthlete=${proxyAthlete}`, {
            method: "PUT",
            body,
          });
          flash("success", "Successfully updated");
        }

        res.refreshWith(
          { modal: "", plan: "", copy: "" },
          { url: "back", hash: "#_" }
        );
      }
    )
    .get(
      "/nutrition/delete-nutrition-plan/:_id",
      async ({ req, res, flash, api }) => {
        const { params, query = {} } = req;
        const { proxyAthlete } = query;
        const { _id } = params;

        if (
          process.browser &&
          !confirm("Are you sure you want to delete this plan?")
        ) {
          return res.backDontScroll();
        }

        await api(`nutrition-plan/${_id}?proxyAthlete=${proxyAthlete}`, {
          method: "DELETE",
        });
        flash("success", "Successfully deleted");

        res.backDontScroll();
      }
    );
};

export default Nutrition;
